import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  useRef,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { TFormField } from '../Components/WizardCmp';
import {
  getAllB2BFormFields,
  getAllB2CFormFields,
  getB2BSubSteps,
  getB2CSubSteps,
} from '../Store/WizardController';
import { useParams, useSearchParams } from 'react-router-dom';
import { saveStepData } from '../Store/ApiCalls';
import { AppContext } from './AppContext';
import { findElAndIndexInDeepArray, transformDataFromApi } from '../helpers';
import { IFormControl } from '../Components/FormControl';
import { InputType } from '../Types/InputType';
import { command } from 'yargs';

//RECAPTCHA
import {
  verifyRecaptchaTokenV3,
  verifyRecaptchaTokenV2,
} from '../Store/ApiCalls';

export interface IWizardContext {
  id: number;
  title: string;
  description: string;
  status: boolean;
}
export type WizardContextType = {
  formFields: TFormField[];
  save: (substepApiName: string, fieldListToSave: TFormField[]) => boolean;
  // updateTodo: (id: number) => void;
  //RECAPTCHA
  showV2Challenge: boolean;
  setShowV2Challenge: (show: boolean) => void;
  handleV2Submit: (v2Token: string | null) => void;
  handleFinalSubmit: (
    substepApiName: string,
    fieldListToSave: TFormField[]
  ) => void;
  isSubmissionSuccessful: boolean;
};

export const WizardContext = createContext<WizardContextType>(null!);

// interface BaseLayoutProps {
//   children: ReactNode;
// }

// const WizardContextProvider: React.FC<BaseLayoutProps> = ({ children }) => {
const WizardContextProvider = (props: { children: ReactNode }) => {
  const appContext = useContext(AppContext);
  //RECAPTCHA
  const navigate = useNavigate();

  // const { formType } = useParams();
  const [formFields, setFormFields] = useState<TFormField[]>([]);
  const [formType, setFormType] = useState('b2c');
  const [searchParams] = useSearchParams(); // @OTOD: Remove this. Duplicate to AppContext

  const [formGuid, setFormGuid] = useState('');

  const [isLoadingData, setIsLoadingData] = useState(true);

  //RECAPTCHA
  const [showV2Challenge, setShowV2Challenge] = useState(false);
  const [isSubmissionSuccessful, setSubmissionSuccessful] = useState(false);
  const finalStepDataRef = useRef<{
    apiName: string;
    fieldList: TFormField[];
  } | null>(null);

  // console.log("here");

  useEffect(() => {
    setFormGuid(searchParams.get('guid')!);

    // console.log(searchParams.get("guid")!);
    // console.log(appContext);
    if (appContext.prefilledData.FormType) {
      setFormType(appContext.prefilledData.FormType.toLowerCase());
      handleFormDataFromAPI();
    } /*else {
      // console.log("aa");
      if (formType === "b2b") {
        setIsLoadingData(false);
        setFormFields(getAllB2BFormFields());
      } else {
        // setFormFields(getAllB2CFormFields());
        // getAllB2CFormFields().then((r: any) => {
        //   console.log("result", r);
        //   // setIsLoadingData(false);
        // });
        // console.log("@1");
        // console.log("@@2", getAllB2CFormFields());
        // setFormFields(getAllB2CFormFields());
      }
    }*/
  }, [appContext.themeProperties]);

  async function handleFormDataFromAPI() {
    const formData = appContext.prefilledData.Data;
    let localFormFields: TFormField[] = [];

    if (appContext.prefilledData.FormType.toLowerCase() === 'b2b') {
      // console.log("#");
      localFormFields = await getAllB2BFormFields();
    } else {
      // console.log("#start from here");
      // localFormFields = getAllB2CFormFields();
      // console.log("##", getAllB2CFormFields());
      localFormFields = await getAllB2CFormFields();

      // localFormFields = [];
      // localFormFields = [];
      // console.log(localFormFields);
    }
    // console.log(localFormFields);
    setIsLoadingData(false);

    // console.log(formFields);
    // console.log(formData);
    if (formData !== undefined) {
      let locallyMatchFieldIdList: any = [];
      // let duplicateFieldsIterator = 0;

      // 1 - Iterate over group fields from API.
      Object.keys(formData).forEach(function (apiStepGroups, index) {
        const fieldIdSearchPattern = apiStepGroups + '-';

        const apiGroupFields = formData[apiStepGroups];

        // 2 - Iterate over subgroup fields gotten from API (1)
        Object.keys(apiGroupFields).forEach(function (fieldName, index2) {
          // console.log(fieldName, idx);
          const apiFieldValue = apiGroupFields[fieldName];

          locallyMatchFieldIdList = [];

          localFormFields.map((_, mapIndex) => {
            if (_['fieldId'] === fieldIdSearchPattern + fieldName) {
              locallyMatchFieldIdList.push(mapIndex);
            }
          });

          if (locallyMatchFieldIdList.length > 1) {
            // console.log(locallyMatchFieldIdList);
            // console.log("duplicates", locallyMatchFieldIdList);
            // duplicateFieldsIterator += locallyMatchFieldIdList.length;
            locallyMatchFieldIdList.map((_a: number) => {
              localFormFields[_a].value = apiFieldValue;
            });
          } else {
            // console.log(
            //   "single field: " + fieldName,
            //   "# index: " + locallyMatchFieldIdList[0],
            //   "# val:" + apiFieldValue
            // );
            if (locallyMatchFieldIdList[0] !== undefined) {
              localFormFields[locallyMatchFieldIdList[0]].value = apiFieldValue;
            }
          }

          // const elToUpdateIndex = findElAndIndexInDeepArray(
          //   localFormFields,
          //   "fieldId",
          //   fieldIdSearchPattern + fieldName
          // );
          // // console.log(elToUpdateIndex, fieldName, apiFieldValue); // Uncomment this line to get the fields is missing mapping on WizzardController.tsx. It will appear some undefined value on it
          // if (elToUpdateIndex) {
          //   localFormFields[elToUpdateIndex.index].value = apiFieldValue;
          // }
        });
      });
    }
    // console.log(localFormFields);
    setFormFields(localFormFields);
  }

  function handleFormDataToAPI(field: TFormField): string | number {
    let r;
    switch (field.inputType) {
      // case InputType.RADIO:
      // case InputType.SELECT:
      //   r = field.options!.indexOf(field.value!) + 1;
      //   break;
      // case InputType.SELECT_CUSTOM:
      //   // @TODO separate by coma
      //   console.log(field.value);
      //   // field.value.map;
      //   break;
      default:
        r = field.value!;
        break;
    }
    return r;
  }

  // --- LÓGICA DE SUBMISSÃO E RECAPTCHA ---

  const handleFinalSubmit = (
    substepApiName: string,
    fieldListToSave: TFormField[]
  ) => {
    //console.log('Final submission triggered. Storing data and starting reCAPTCHA check...');
    if (process.env.REACT_APP_RECAPTCHA_ENABLED === 'true') {
      //console.log('reCAPTCHA is enabled. Storing data and starting verification...');
      finalStepDataRef.current = {
        apiName: substepApiName,
        fieldList: fieldListToSave,
      };
      executeRecaptchaV3();
    } else {
      //console.log('reCAPTCHA is disabled. Saving data directly.');
      saveStep(substepApiName, fieldListToSave);
    }
  };

  const executeRecaptchaV3 = async () => {
    const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHAV3_APIKEY;
    if (!recaptchaSiteKey || !window.grecaptcha?.enterprise) {
      console.error('reCAPTCHA v3 not configured or loaded.');
      alert('A security error occurred. Please refresh the page.');
      return;
    }
    try {
      const token = await window.grecaptcha.enterprise.execute(
        recaptchaSiteKey,
        { action: 'SUBMIT_FORM' }
      );
      const verificationResult = await verifyRecaptchaTokenV3(
        token,
        'SUBMIT_FORM'
      );

      if (verificationResult?.isHuman) {
        //console.log('v3 Verification successful! Now saving data...');
        if (finalStepDataRef.current) {
          saveStep(
            finalStepDataRef.current.apiName,
            finalStepDataRef.current.fieldList
          );
        }
      } else if (verificationResult?.challenge === 'recaptcha_v2') {
        //console.log('v3 score is low. Triggering v2 challenge.');
        setShowV2Challenge(true);
      } else {
        alert('Sorry, we could not verify your request. Please try again.');
      }
    } catch (error) {
      console.error('Error during the reCAPTCHA v3 process:', error);
    }
  };

  const handleV2Submit = async (v2Token: string | null) => {
    if (!v2Token) {
      alert('Please complete the reCAPTCHA challenge.');
      return;
    }
    try {
      const finalResult = await verifyRecaptchaTokenV2(v2Token, 'SUBMIT_FORM');
      if (finalResult?.success) {
        //console.log('v2 Verification successful! Now saving data...');
        if (finalStepDataRef.current) {
          saveStep(
            finalStepDataRef.current.apiName,
            finalStepDataRef.current.fieldList
          );
        }
      } else {
        alert('Final verification failed. Please contact support.');
        setShowV2Challenge(false);
      }
    } catch (error) {
      console.error('Error during the reCAPTCHA v2 process:', error);
    }
  };

  function saveStep(substepApiName: string, fieldList: TFormField[]): boolean {
    // console.log(substepApiName);

    // Updating local fields
    const formFieldsCopy = [...formFields];
    fieldList.map((i, index) => {
      const indexToUpdate = formFieldsCopy.findIndex(
        (e) => e.internalId === i.internalId
      );
      formFieldsCopy[indexToUpdate].value = i.value;
    });
    // console.log(fieldList);
    // console.log(formFieldsCopy);
    // console.log(formFields.filter((_) => _.isFieldVisible === true));
    setFormFields(formFields);

    // Creating a key-value pair to submit the step data;
    const fieldsToSend = fieldList
      .filter((_) => _.isFieldVisible !== false)
      .map((_) => {
        return {
          [_.fieldId.replace(substepApiName + '-', '')]: handleFormDataToAPI(_),
        };
      });

    // console.log(fieldsToSend);

    const isMarried = [2, 3, 4].includes(+formFieldsCopy[10].value!);

    const substepList =
      formType === 'b2c' ? getB2CSubSteps() : getB2BSubSteps();

    const substepIndex = substepList.findIndex(
      (el) => el.apiName === substepApiName
    );

    // console.log("is marreid", isMarried);
    // console.log(substepList.length, substepIndex);

    let isFinished = false;

    if (formType === 'b2c') {
      // console.log("#", isMarried, substepIndex);
      if (isMarried && substepIndex === 7) {
        // console.log("#", isMarried, substepIndex);
        isFinished = true;
      } else if (!isMarried && substepIndex === 6) {
        isFinished = true;
      }
    } else if (formType === 'b2b') {
      if (substepIndex == 2) {
        isFinished = true;
      }
    }

    // console.log("is to Finish", isFinished);

    // const dataToSave = {};

    // console.log(fieldsToSend);
    const dataToSave = {
      Guid: formGuid,
      Step: substepIndex + 1,
      IsFinished: isFinished,
      Data: {
        [substepApiName]: Object.assign({}, ...fieldsToSend),
      },
    };
    // console.log(appContext);
    // console.log(dataToSave);
    // const stepObj = currentSubsteps.filter(_=>_);
    // console.log(stepObj);
    // const dataToSave: any = handleFormDataToAPI();
    setIsLoadingData(true);
    saveStepData(appContext.prefilledData.URLToSave, dataToSave)
      .then((r) => {
        // console.log(r);
        if (dataToSave.IsFinished) {
          console.log(
            'Final submission successful. Signaling for navigation...'
          );
          setSubmissionSuccessful(true);
        }
      })
      .finally(() => {
        // console.log("finally");
        setIsLoadingData(false);
      });
    // setIsLoadingData(false);

    return false;
  }

  return (
    <WizardContext.Provider
      value={{
        formFields: formFields,
        save: saveStep,
        //RECAPTCHA
        showV2Challenge,
        setShowV2Challenge,
        handleFinalSubmit,
        handleV2Submit,
        isSubmissionSuccessful,
      }}
    >
      {!isLoadingData && props.children}
    </WizardContext.Provider>
  );
};

export default WizardContextProvider;
